import React from 'react';
import { Box } from '@mui/material';
import GreetingCard from './GreetingCard';
import StatsGrid from './StatsGrid';
import ChartSection from './ChartSection';
import TopMembers from './InsightsWithCalendar';
import MemberLocationsCard from './MemberLocationsCard';
import useDashboardData from './useDashboardData'; 

const Dashboard = () => {
  const {
    userFullName,
    currentTime,
    stats,
    violationsByMonth,
    maintenanceByMonth,
    workOrderChartData,
  } = useDashboardData();

  return (
    <Box sx={{ padding: 3 }}>
      <GreetingCard userFullName={userFullName} currentTime={currentTime} />
      <StatsGrid stats={stats} />
      <ChartSection
  columns={3}
  visibleCharts={['violations', 'maintenance', 'overview']}
  violationsByMonth={violationsByMonth}
  maintenanceByMonth={maintenanceByMonth}
  workOrderChartData={workOrderChartData}
/>

      <Box sx={{ marginTop: 5 }}>
        <TopMembers />
      </Box>
      <MemberLocationsCard />
    </Box>
  );
};

export default Dashboard;
